import { render, staticRenderFns } from "./CompaniesByCountryAndAllyTypeChart.vue?vue&type=template&id=340d5793&"
import script from "./CompaniesByCountryAndAllyTypeChart.vue?vue&type=script&lang=js&"
export * from "./CompaniesByCountryAndAllyTypeChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports